import { useEffect } from 'react';
import Lenis from 'lenis';

// 목업(evs.com)식 부드러운 관성 스크롤.
// ── 인스턴스 노출(2026-08-02) ──
//   회사소개 서브페이지: 헤더 서브메뉴(인사말·조직도…) 클릭 시 "같은 페이지의 해당 섹션으로 부드럽게 스크롤"
//   해야 하므로, 훅 외부(Header/Company 페이지)에서 Lenis 인스턴스에 접근할 수 있어야 한다.
//   → 모듈 스코프 싱글턴으로 보관하고 getLenis()로 제공. (앱 전체에 Lenis는 1개뿐 — App에서 useLenis 1회 호출)
let lenisInstance: Lenis | null = null;

export function getLenis(): Lenis | null {
  return lenisInstance;
}

// 고정 헤더 높이 보정치(px). 섹션 상단이 헤더에 가리지 않도록 스크롤 목표를 위로 당김.
//   헤더 로고행+메뉴행 ≈ 142~150px 실측 → 여유 포함 150.
const HEADER_OFFSET = 150;

// 섹션 id로 부드럽게 스크롤.
//   ★직접 URL 로드(/company#history) 대응: React 이펙트 순서상 자식(Company) 이펙트가
//    부모(App)의 useLenis 초기화보다 먼저 실행돼 이 함수 호출 시점에 Lenis가 아직 null일 수 있다.
//    그때 네이티브 scrollTo를 쓰면 직후 초기화된 Lenis가 스크롤을 0으로 덮어써버림 → 스크롤 실패.
//    따라서 Lenis(및 대상 요소)가 준비될 때까지 짧게 재시도(최대 ~1s)한 뒤 Lenis로 스크롤한다.
//    클라이언트 이동(홈→/company#id)에선 Lenis가 이미 있으므로 즉시 동작.
export function scrollToSection(id: string, attempt = 0) {
  const el = document.getElementById(id);
  const lenis = getLenis();
  if ((!el || !lenis) && attempt < 24) {
    setTimeout(() => scrollToSection(id, attempt + 1), 40);
    return;
  }
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -HEADER_OFFSET, duration: 1.2 });
  else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET, behavior: 'smooth' }); // 최후 폴백
}

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisInstance = lenis;
    let raf = 0;
    const loop = (time: number) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
}
